// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import { inputStyles } from "@store/Themes/common/mixins";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { css } from "styled-components";

export const sasInputStyles = () => {
    return css`
        ${inputStyles()}

        &:focus {
            outline: none;
            border: ${pxToRem(2)} solid ${getColor("secondary")};
        }
    `;
};
